import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { resetPasswordComponent } from './resetPassword/resetPassword.component';
import { changePasswordComponent } from './changePassword/changePassword.component';
import { Error404Component } from './error404/error404.component';
import { Error500Component } from './error500/error500.component';
import {UsersService} from "../users/users/users.service";


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        LoginComponent,
        resetPasswordComponent,
        changePasswordComponent,
        Error404Component,
        Error500Component
    ],
    providers: [
        UsersService
    ],
    exports: [
        RouterModule,
        LoginComponent,
        resetPasswordComponent,
        changePasswordComponent,
        Error404Component,
        Error500Component
    ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// ./src/app/routes/pages/pages.module.ts